import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  InputGroup,
} from "react-bootstrap";
import { resetPassword } from "../../services/api";
import { getStoredUser } from "../../utils/authStorage";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPasswords, setShowPasswords] = useState({
    new: false,
    confirm: false,
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const user = getStoredUser() || {};

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
  };

  const toggleShow = (field) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Password baru dan konfirmasi password tidak cocok");
      return;
    }

    if (formData.newPassword.length < 6) {
      setError("Password baru minimal 6 karakter");
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword({
        userid: user.userid,
        newPassword: formData.newPassword,
        unik_id: user.unik_id || user.userid,
      });

      if (response.data.success) {
        setSuccess("Password berhasil diubah");
        setFormData({ newPassword: "", confirmPassword: "" });
      } else {
        setError(response.data.message || "Gagal mengubah password");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Terjadi kesalahan. Silakan coba lagi."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col>
          <h2>
            <i className="fas fa-lock me-2"></i>
            Ganti Password
          </h2>
          <p className="text-muted">
            Ganti password untuk akun <strong>{user.username}</strong> ({user.userid})
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} md={6} lg={5}>
          <Card className="shadow-sm">
            <Card.Header>
              <h5 className="mb-0">
                <i className="fas fa-key me-2"></i>
                Ubah Password
              </h5>
            </Card.Header>
            <Card.Body>
              {success && (
                <Alert variant="success" dismissible onClose={() => setSuccess("")}>
                  <i className="fas fa-check-circle me-2"></i>
                  {success}
                </Alert>
              )}
              {error && (
                <Alert variant="danger" dismissible onClose={() => setError("")}>
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Password Baru</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPasswords.new ? "text" : "password"}
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      placeholder="Masukkan password baru (min. 6 karakter)"
                      required
                      autoComplete="new-password"
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => toggleShow("new")}
                      tabIndex={-1}
                    >
                      <i className={`fas fa-eye${showPasswords.new ? "-slash" : ""}`}></i>
                    </Button>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Konfirmasi Password Baru</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPasswords.confirm ? "text" : "password"}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="Ulangi password baru"
                      required
                      autoComplete="new-password"
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => toggleShow("confirm")}
                      tabIndex={-1}
                    >
                      <i className={`fas fa-eye${showPasswords.confirm ? "-slash" : ""}`}></i>
                    </Button>
                  </InputGroup>
                </Form.Group>

                <div className="d-grid">
                  <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Menyimpan...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Simpan Password Baru
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ChangePassword;
